





































































































import { Component, Vue } from "vue-property-decorator";
import { PatientFilter } from "@/store/modules/types";
import { BPopover, BFormInput, BOverlay } from "bootstrap-vue";
import { formatPhone } from "@/utils";

@Component({
  components: {
    BPopover,
    BFormInput,
    BOverlay,
  },
  filters: {
    phone: formatPhone,
  },
})
export default class PatientSearchPopover extends Vue {
  id = "patient-search-popover";
  target = "patient-search-target";
  filter: PatientFilter = {
    firstName: "",
    lastName: "",
    insurerId: "",
    insurerMemberId: "",
    EMR_ID: "",
    withPhoneErrors: false,
    pageNumber: 1,
    rowsPerPage: 10,
  };
  patients: Array<any> = [];
  loading = false;
  async getPatients() {
    this.loading = true;
    try {
      const data = await this.$store.dispatch("patients/getList", this.filter);
      this.patients = data.pageRows;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  select(patient) {
    this.$emit("selected", patient.id);
    this.close();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    this.getPatients();
  }
}
